import React from 'react'
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link } from "gatsby"
import * as Action from '../state/actions';
import Social from './social';

const MenuStyled = styled.div`
  position: fixed;
  text-align: center;
  top: 0;
  right: 0;
  z-index: 100;

  .burger {
    border-bottom: 2px solid #000;
    border-top: 2px solid #000;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 16px;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    z-index: 10;

    &::after {
      background: #000;
      height: 2px;
      content: '';
      display: block;
    }
  }

  ${({ active }) => !active && `
    .container {
      display: none;
    }
  `}

  ${({ active }) => active && `
    .container {
      align-items: center;
      background: #fff;
      display: flex;
      flex-direction: column;
      height: 100vh;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      width: 100vw;
    }
  `}

  ul {
    margin-bottom: 30px;
  }

  li {
    font-size: 50px;

    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  a {
    color: #000;
    text-decoration: none;
  }

  p {
    color: #777373;
    font-size: 16px;
    font-family: aktiv-grotesk, sans-serif;
    line-height: 1.4;
    max-width: 300px;
    margin: 0 auto 30px;

    &:before {
      background: #e98286;
      content: '';
      display: block;
      height: 4px;
      width: 60px;
      margin: 0 auto 30px;
    }
  }
`

const Menu = (props) => (
  <MenuStyled active={props.menu}>
    <div 
      onClick={() => props.dispatch(Action.toggleMenu(!props.menu))}
      className="burger" 
    />
    <div className="container">
      <ul>
        <li>
          <Link onClick={() => props.dispatch(Action.toggleMenu(!props.menu))} to="/">Home</Link>
        </li>
        <li>
          <Link onClick={() => props.dispatch(Action.toggleMenu(!props.menu))} to="/personalities">Personalities</Link>
        </li>
        <li>
          <Link onClick={() => props.dispatch(Action.toggleMenu(!props.menu))} to="/">Book a Trip</Link>
        </li>
      </ul>
      <p>Share this quiz with your friends and compare your travel personality types</p>
      <Social />
    </div>
  </MenuStyled>
);

const mapStateToProps = ({ menu = false }) => {
  return { menu };
}

export default connect(mapStateToProps)(Menu);